<template>
  <form id="formNonBuku" @submit.prevent="submitAddNonBuku" class="form">
    <!-- <button class="btn btn-danger" @click="resetForm">Reset</button> -->
    <Informasi
      :description="descriptionVal"
      :onEditorChange="onEditorChange"
      :listPenerbit="listPenerbit"
      :listCategory="listCategory"
      :getCategoryVal="getCategoryVal"
      :getSubCategoryVal="getSubCategoryVal"
      :listSubCategory="listSubCategory"
      :listSub2Category="listSub2Category"
    ></Informasi>
    <!-- <div v-for="(dp,index) in dataPaket" :key="index">
            <div>{{dp.name}}</div>
          </div> -->
    <Harga
      :getPaketData="getPaketData"
      :paketData="paketData"
      :deletePaket="deletePaket"
      v-model="findPaket"
      :dataPaket="dataPaket"
      :ppnValue="ppnValue"
      :renderComponent="renderComponent"
      :isChecked="isChecked"
      :findProductPacket="findProductPacket"
      :addPaket="addPaket"
    ></Harga>
    <Media></Media>
    <Spesifikasi></Spesifikasi>
    <!-- <button type="button" @click="tst">test</button> -->
    <button type="submit" id="uploadBtn" class="btn btn-primary">
      <i class="fa fa-cloud-upload"></i> Upload Produk
    </button>
    <button @click="back" type="button" class="btn btn-secondary">
      <i class="fa fa-times"></i> Batal
    </button>
  </form>
</template>
<script>
import Informasi from "./PartsOfLayout/Informasi";
import Harga from "./PartsOfLayout/Harga";
import Media from "./PartsOfLayout/Media";
import Spesifikasi from "./PartsOfLayout/Spesifikasi";

import { mapGetters } from "vuex";
import $ from "jquery";

// import Vue from "vue";

// Vue.config.silent = true;
import axios from "axios";
export default {
  data() {
    return {
      descriptionVal: "",
      renderComponent: true,
      isChecked: false,
      ppnValue: 0,
      findPaket: "express",
      dataPaket: [],
      addProductid: "",
      paketData: [],
      listPenerbit: [],
      listCategory: [],
      catVal: 0,
      subCatVal: 0,
      listSubCategory: [],
      listSub2Category: [],
    };
  },
  watch: {
    findPaket() {
      this.findProductPacket();
    },
    catVal() {
      this.getSubCategory();
    },
    subCatVal() {
      this.getSub2Category();
    },
  },
  components: {
    Informasi,
    Harga,
    Media,
    Spesifikasi,
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
    }),
  },
  updated() {
    if (this.listSub2Category.length === 0) {
      $("#nonBookSub2Category").addClass("d-none");
    }
  },
  async mounted() {
    await this.$nextTick();
    // $(".toggle_table").bootstrapToggle();
    this.togglerPajak();
    this.getPaketData();
    this.listPenerbitAndCategory();
    this.getSubCategory();
    this.getSub2Category();
    this.getBarangCategory();
  },
  methods: {
    filterCatNonBook(listCat) {
      return listCat.id != 22 && listCat.id != 23;
    },
    getBarangCategory() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/api/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          let catList = data.data.data[0].submenu.menu;
          // this.listCategory = data.data.data[0].submenu.menu;
          this.listCategory = catList.filter(this.filterCatNonBook);
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catVal].submenu;
        });
    },
    getCategoryVal() {
      $("#loadingCategory1").removeClass("d-none");
      $("#nonBookSubCategory").addClass("d-none");
      var index = $("#nonBookCategory").prop("selectedIndex");
      if (index > 2) {
        this.catVal = index + 2;
      } else {
        this.catVal = index;
      }
      this.subCatVal = 0;
      $("#nonBookSub2Category").addClass("d-none");
    },
    getPaketData() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/api/backendseller/paket/paket_api/tempPacket/${this.user.id}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.paketData = data;
          console.log(this.paketData);
        });
    },
    addPaket(idProd, elem) {
      var $this = $(elem);
      var val = $this.val();
      if (val == "") {
        console.log("no input");
      } else {
        console.log(val);
      }
      // console.log(idProd,)
      let qtyVal = $(`${elem}`).val();
      if (qtyVal === 0 || qtyVal === "") {
        this.$toast.error(`Masukan Jumlah Quantity Paket`);
      } else {
        // let qtyVal = 1
        var formdata = new FormData();
        formdata.append("product_id", idProd);
        formdata.append("qty", qtyVal);
        formdata.append("mall_id", this.user.id);

        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };

        fetch(
          "https://siplah.eurekabookhouse.co.id/api/backendseller/paket/paket_api/addPacket",
          requestOptions
        ).then(() => {
          // console.log(data);
          setTimeout(() => {
            this.dataPaket = [];
            this.getPaketData();
          }, 300);
        });
      }
    },
    deletePaket(paketId) {
      // console.log(paketId)
      fetch(
        `https://siplah.eurekabookhouse.co.id/api/backendseller/paket/paket_api/delPacket/${paketId}`
      )
        .then((response) => response.json())
        .then(() => {
          // console.log(data);
          this.getPaketData();
        });
    },
    findProductPacket() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/api/backendseller/paket/paket_api/cariProduk?cari=${this.findPaket}&mall_id=${this.user.id}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.dataPaket = data;
        });
    },
    /* eslint-disable no-unused-vars */
    onEditorChange({ quill, html, text }) {
      this.descriptionVal = html;
    },
    tst() {
      // console.log(document.getElementById("coverUpload").files);
    },
    listPenerbitAndCategory() {
      fetch(
        "https://siplah.eurekabookhouse.co.id/api/backendseller/katalog/produk_api/detailproduk/"
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data.listpenerbit, "penerbit brand");
          this.listPenerbit = data.listpenerbit;
          // this.listCategory = data.listcat;
        });
    },
    getSubCategory() {
      this.subCatVal = 0;
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/api/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catVal].submenu;
          $("#loadingCategory1").addClass("d-none");
          $("#nonBookSubCategory").removeClass("d-none");
        });
    },
    getSubCategoryVal() {
      $("#loadingCategory2").removeClass("d-none");
      $("#nonBookSub2Category").addClass("d-none");
      var index = $("#nonBookSubCategory").prop("selectedIndex");
      this.subCatVal = index;
    },
    getSub2Category() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/api/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSub2Category =
            data.data.data[0].submenu.menu[this.catVal].submenu[
              this.subCatVal
            ].submenu;
          $("#loadingCategory2").addClass("d-none");
          $("#nonBookSub2Category").removeClass("d-none");
        });
    },
    submitAddNonBuku() {
      try {
        document.getElementById("coverUpload").files[0].name;
      } catch (error) {
        this.$swal.fire(
          `<span style='font-size:17px'>Perhatian</span>`,
          "Foto utama tidak boleh kosong!",
          "info"
        );
      }

      if (
        $("#nonBookUnitPrice").val() === "0" ||
        $("#nonBookUnitPrice").val() === ""
      ) {
        this.$swal.fire(
          `<span style='font-size:17px'>Perhatian</span>`,
          "Harga Tidak Boleh 0 atau Kosong",
          "info"
        );
      } else {
        this.formDataSubmit();
      }
    },
    formDataSubmit() {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=cka0bd7kh7gs6cvt6tmvb7s93vtn3rav");

      let defaultPhotoCover = new File([null], null, {
        type: "image/jpeg",
      });

      let defaultPhoto1 = new File([null], null, {
        type: "image/jpeg",
      });

      let defaultPhoto2 = new File([null], null, {
        type: "image/jpeg",
      });

      let defaultPhoto3 = new File([null], null, {
        type: "image/jpeg",
      });

      if (
        $("#nonBookUnitPrice")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Harga tidak boleh kurang dari 0",
          "warning"
        );
      } else if (
        $("#nonBookMaxNegoPrice")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Harga tidak boleh kurang dari 0",
          "warning"
        );
      } else if (
        $("#nonBookMinWholesale1")
          .val()
          .includes("-") ||
        $("#nonBookMinWholesale2")
          .val()
          .includes("-") ||
        $("#nonBookMinWholesale3")
          .val()
          .includes("-") ||
        $("#nonBookMinWholesale4")
          .val()
          .includes("-") ||
        $("#nonBookWholesalePrice1")
          .val()
          .includes("-") ||
        $("#nonBookWholesalePrice2")
          .val()
          .includes("-") ||
        $("#nonBookWholesalePrice3")
          .val()
          .includes("-") ||
        $("#nonBookWholesalePrice4")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Pembelian Minimum tidak boleh kurang dari 1",
          "warning"
        );
      } else if (
        $("#nonBookWeight")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Berat tidak boleh kurang dari 0",
          "warning"
        );
      } else if (
        $("#nonBookStock")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Stok tidak boleh kurang dari 0",
          "warning"
        );
      } else if (
        $("#nonBookLength")
          .val()
          .includes("-") ||
        $("#nonBookWidth")
          .val()
          .includes("-") ||
        $("#nonBookHeight")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Panjang Lebar dan Tinggi tidak boleh kurang dari 0",
          "warning"
        );
      } else {
        var formdata = new FormData();
        formdata.append("produk", $("#nonBookName").val());
        formdata.append("produk_tag", $("#nonBookTag").val());
        formdata.append("layout", "3");
        formdata.append("jenis_pkp", this.user.type);
        formdata.append("model", $("#nonBookCode").val());
        formdata.append("seo", $("#nonBookSeo").val());
        formdata.append("l_merk", $("#nonBookManufacturer").val());
        formdata.append(
          "category_id",
          this.listSub2Category.length === 0
            ? $("#nonBookSubCategory").val()
            : $("#nonBookSub2Category").val()
        );
        formdata.append(
          "KategoriSub",
          this.listSub2Category.length === 0
            ? $("#nonBookSubCategory").val()
            : $("#nonBookSub2Category").val()
        );
        formdata.append("description", this.descriptionVal);
        formdata.append(
          "harga",
          $("#nonBookUnitPrice")
            .val()
            .replace(/\./g, "")
        );
        formdata.append("nonBookItemUnit", $("#nonBookItemUnit").val());
        formdata.append(
          "harga_nego",
          $("#nonBookMaxNegoPrice")
            .val()
            .replace(/\./g, "")
        );

        formdata.append("minGrosir1", $("#nonBookMinWholesale1").val());
        formdata.append(
          "hargaGrosir1",
          $("#nonBookWholesalePrice1")
            .val()
            .replace(/\./g, "")
        );
        formdata.append("minGrosir2", $("#nonBookMinWholesale2").val());
        formdata.append(
          "hargaGrosir2",
          $("#nonBookWholesalePrice2")
            .val()
            .replace(/\./g, "")
        );
        formdata.append("minGrosir3", $("#nonBookMinWholesale3").val());
        formdata.append(
          "hargaGrosir3",
          $("#nonBookWholesalePrice3")
            .val()
            .replace(/\./g, "")
        );
        formdata.append("minGrosir4", $("#nonBookMinWholesale4").val());
        formdata.append(
          "hargaGrosir4",
          $("#nonBookWholesalePrice4")
            .val()
            .replace(/\./g, "")
        );
        formdata.append("produksi", $("#nonBookOrigin").val());
        formdata.append("jml_halaman", ""); //belum
        formdata.append("barang_produsen", $("#nonBookProducer").val());
        formdata.append("kondisi", $("#nonBookCondition").val());
        formdata.append(
          "s_gudang",
          $("#nonBookStock")
            .val()
            .replace(/\./g, "")
        );
        formdata.append("garansi", $("#nonBookWarranty").val());

        formdata.append(
          "dpp_price",
          Number(
            $("#dpp")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "dpp_nilai_lain",
          Number(
            $("#dppNilaiLainHargaSatuan")
              .text()
              .replace(/[^\d]/g, "")
          )
        );
        formdata.append(
          "ppn_price",
          Number(
            $("#ppn")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "pph_price",
          Number(
            $("#pph")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "dana_terima",
          Number(
            $("#terima")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        // Payload Harga Nego
        formdata.append(
          "dpp_price_nego",
          Number(
            $("#dppNego")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "dpp_nilai_lain_nego",
          Number(
            $("#dppNilaiLainNego")
              .text()
              .replace(/[^\d]/g, "")
          )
        );
        const ppnNegoText = $("#ppnNego")
          .text()
          .trim();
        const cleanedPpnNego = ppnNegoText.replace(/[^\d]/g, ""); // Hanya ambil digit angka

        formdata.append("ppn_nego", cleanedPpnNego || 0);

        formdata.append(
          "pph_price_nego",
          Number(
            $("#pphNego")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append(
          "dana_terima_nego",
          Number(
            $("#terimaNego")
              .text()
              .replace(/[^\d]/g, "")
          )
        );

        formdata.append("berat", $("#nonBookWeight").val());
        formdata.append("panjang", $("#nonBookLength").val());
        formdata.append("lebar", $("#nonBookWidth").val());
        formdata.append("tinggi", $("#nonBookHeight").val());
        formdata.append("d_status", 0);
        formdata.append("processor", $("#nonBookProcessor").val());
        formdata.append("memory", $("#nonBookMemoryRam").val());
        formdata.append("harddisk", $("#nonBookHarddisk").val());
        formdata.append("media_player", $("#nonBookDvd").val());
        formdata.append("monitor", $("#nonBookMonitor").val());
        formdata.append("availability", $("#nonBookAvailability").val());
        formdata.append("aplikasi_on", $("#nonBookApplication").val());
        formdata.append("ppnTagItem", $("#tagPpnNonbok").val());

        formdata.append("mall_id", this.user.id);
        formdata.append("item_type", 2);
        formdata.append(
          "filefotoutama",
          document.getElementById("coverUpload").files[0],
          document.getElementById("coverUpload").files.length === 0
            ? defaultPhotoCover.name
            : document.getElementById("coverUpload").files[0].name
        );

        formdata.append(
          "filefoto0",
          document.getElementById("photoUpload1").files.length === 0
            ? defaultPhoto1
            : document.getElementById("photoUpload1").files[0],
          document.getElementById("photoUpload1").files.length === 0
            ? defaultPhoto1.name
            : document.getElementById("photoUpload1").files[0].name
        );
        formdata.append(
          "filefoto1",
          document.getElementById("photoUpload2").files.length === 0
            ? defaultPhoto2
            : document.getElementById("photoUpload2").files[0],
          document.getElementById("photoUpload2").files.length === 0
            ? defaultPhoto2.name
            : document.getElementById("photoUpload2").files[0].name
        );
        formdata.append(
          "filefoto2",
          document.getElementById("photoUpload3").files.length === 0
            ? defaultPhoto3
            : document.getElementById("photoUpload3").files[0],
          document.getElementById("photoUpload3").files.length === 0
            ? defaultPhoto3.name
            : document.getElementById("photoUpload3").files[0].name
        );

        // for (var pair of formdata.entries()) {
        //   console.log(pair[0] + ", " + pair[1]);
        // }

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        this.$swal
          .fire({
            title: "Anda yakin?",
            text: "Anda yakin ingin menambah produk ini ke dalam toko anda?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
          })
          .then((result) => {
            if (result.isConfirmed) {
              let timerInterval = timerInterval;
              this.$swal.fire({
                title: "<span style='font-size:17px'>Sedang diproses</span>",
                html: "Mohon Tunggu...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                width: 350,
                didOpen: () => {
                  this.$swal.showLoading();
                  timerInterval = setInterval(() => {
                    const content = this.$swal.getContent();
                    if (content) {
                      const b = content.querySelector("b");
                      if (b) {
                        b.textContent = this.$swal.getTimerLeft();
                      }
                    }
                  }, 100);
                },
              });
              fetch(
                "https://siplah.eurekabookhouse.co.id/api/backendseller/katalog/produk_api/addproduk",
                requestOptions
              )
                .then((response) => response.json())
                .then((data) => {
                  this.$swal.close();
                  this.$router.push({
                    path: "/product",
                  });
                  this.$swal.fire("Sukses!", data.title, "success");
                })
                .catch((error) => console.log("error", error));
            }
          });
      }
    },
    togglerPajak() {
      let gThis = this;
      /* eslint-disable no-unused-vars */
      setInterval(() => {
        $(".toggle_table").bootstrapToggle();
      }, 200);
      $(".toggle_table").on("change", function() {
        gThis.changePajak();
      });
    },
    async changePajak() {
      if (this.isChecked === false) {
        this.ppnValue = 1;
        this.isChecked = true;
        return this.$swal.fire(
          `<span style='font-size:17px'>PPN 10% Diaktifkan</span>`,
          "Pajak akan ditanggung oleh toko!",
          "info"
        );
      } else {
        this.ppnValue = 0;
        this.isChecked = false;
        return this.$swal.fire(
          `<span style='font-size:17px'>PPN 10% Tidak Diaktifkan</span>`,
          "Pajak akan ditanggung oleh sekolah!",
          "info"
        );
        // return this.$toast.error('PPN 10% Tidak Diaktifkan',{icon: true,})
      }
    },
    back() {
      window.history.back();
    },
    resetForm() {
      $("#addProduct").trigger("reset");
      this.description = "";
    },
  },
};
</script>
